<table #table class="grid-table">
    <tr *ngFor="let row of images | chunk:4">
        <td cmGridCell [image]="image" *ngFor="let image of row"></td>
    </tr>
</table>
